module.exports = __webpack_public_path__ + "img/321.17e15fc2.png";